import { QueryClient } from '@tanstack/react-query';

/**
 * Shared react-query client for the Wave portal. Query options live in
 * `@round/api` (`*.queries.ts`); features consume them through this client.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 30_000,
        },
    },
});
